import { render, staticRenderFns } from "./QuickTipsIntegrationSpecification.vue?vue&type=template&id=6d7f6848&scoped=true&"
import script from "./QuickTipsIntegrationSpecification.vue?vue&type=script&lang=js&"
export * from "./QuickTipsIntegrationSpecification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7f6848",
  null
  
)

export default component.exports